var _filter, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfComparatorIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pdf1Grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#66BB6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#388E3C"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pdf2Grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#EF5350"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#D32F2F"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadowComp",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 1,
    dy: 2,
    stdDeviation: 1.5,
    floodOpacity: 0.3
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 28,
    height: 40,
    rx: 4,
    fill: "url(#pdf1Grad)",
    filter: "url(#shadowComp)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "white",
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 16,
    height: 3,
    rx: 1.5,
    fill: "white",
    opacity: 0.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24,
    width: 18,
    height: 3,
    rx: 1.5,
    fill: "#FFEB3B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 30,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "white",
    opacity: 0.7
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 4,
    width: 28,
    height: 40,
    rx: 4,
    fill: "url(#pdf2Grad)",
    filter: "url(#shadowComp)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 12,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "white",
    opacity: 0.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 18,
    width: 16,
    height: 3,
    rx: 1.5,
    fill: "white",
    opacity: 0.7
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 24,
    width: 18,
    height: 3,
    rx: 1.5,
    fill: "#FFEB3B"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 30,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "white",
    opacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 50,
    r: 12,
    fill: "#1976D2",
    filter: "url(#shadowComp)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 47 L38 47 M34 43 L38 47 L34 51",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53 L26 53 M30 49 L26 53 L30 57",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfComparatorIcon);
export default __webpack_public_path__ + "static/media/pdf-comparator-icon.5f49cb22d400542e526cddc7762907b6.svg";
export { ForwardRef as ReactComponent };